import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { ClaimIdSchema } from "./agency-unlock.js";
import { ReportIdSchema } from "../primitives/ids.js";
import { TraceContextSchema } from "./trace.js";
import { RelaunchPreviewIdSchema } from "./relaunch-preview.js";
/** crawl-site-draft-job-payload.v1.0 — BullMQ worker job for draft-only relaunch import. */
export const CrawlSiteDraftJobPayloadV1Schema = z
    .object({
    schemaVersion: z.literal("crawl-site-draft-job-payload.v1.0"),
    jobKind: z.literal("CRAWL_SITE_DRAFT"),
    relaunchPreviewId: RelaunchPreviewIdSchema,
    claimId: ClaimIdSchema,
    agencyId: AgencyIdSchema,
    publicReportRef: ReportIdSchema,
    projectId: ProjectIdSchema,
    draftId: z.string().min(1),
    generatedByUserId: z.string().min(1),
    trace: TraceContextSchema,
})
    .strict();
export const CRAWL_SITE_DRAFT_QUEUE_NAME = "tier0-crawl-site-draft";
export function crawlSiteDraftEnqueueJobId(claimId) {
    return `enr:crawl-draft:${claimId}`;
}
//# sourceMappingURL=crawl-site-draft-job-payload.js.map